<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <select [formControl]="control" [attr.name]="name" [attr.disabled]="schema.readOnly" class="form-control">
    <ng-container *ngFor="let option of selectOptions; index as i; trackBy: optionIdentity">
      <optgroup *ngIf="option.options" [attr.label]="option.label">
        <ng-container *ngFor="let suboption of option.options; index as i; trackBy: optionIdentity">
          <ng-container *ngTemplateOutlet="plainOption; context: suboption"></ng-container>
        </ng-container>
      </optgroup>
      <ng-container *ngIf="!option.options">
        <ng-container *ngTemplateOutlet="plainOption; context: option"></ng-container>
      </ng-container>
    </ng-container>
    <ng-template #plainOption let-label="label" let-value="value">
      <option [ngValue]="value">{{ label }}</option>
    </ng-template>
  </select>
  <input *ngIf="schema.readOnly" [attr.name]="name" type="hidden" [formControl]="control" />
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/select.widget.html